'use client'

import { SubscribeButton } from '@components/button/SubscribeButton'
import UIFlex from '@components/ui/UIFlex'
import UIImage from '@components/ui/UIImage'
import UILink from '@components/ui/UILink'
import UIText from '@components/ui/UIText'
import { Box } from '@mui/joy'
import color from '@ui/style/color.theme'
import { pxToRem } from '@ui/style/muiTheme'

interface AuthorSlideItemProps {
	idx: string
	src: string
	name: string
	position: string
	email: string
	isSubscribed?: boolean
}
const AuthorSlideItem = ({
	idx,
	src,
	name,
	position,
	email,
	isSubscribed,
}: AuthorSlideItemProps) => {
	return (
		<UIFlex
			flexDirection="row"
			alignItems="center"
			padding={{ xs: pxToRem(18), md: pxToRem(16), xl: pxToRem(18) }}
			borderRadius={pxToRem(4)}
			sx={{
				background: color.colGray1,
				'&>*:not(:first-child)': {
					marginLeft: pxToRem(24),
				},
			}}
		>
			<UIFlex
				flexDirection="row"
				alignItems="center"
				flexGrow="1"
				minWidth="0"
				sx={{
					'&>*:not(:first-child)': {
						marginLeft: pxToRem(12),
					},
				}}
			>
				<UILink href={`/journalist/${idx}`}>
					<Box
						width={pxToRem(48)}
						overflow="hidden"
						borderRadius="9999px"
						flexShrink="0"
						minWidth="0"
					>
						<UIImage ratio={1} src={src} alt="" />
					</Box>
				</UILink>
				<UIFlex
					sx={{
						'&>*:not(:first-child)': {
							marginTop: pxToRem(2),
						},
					}}
				>
					<UILink href={`/journalist/${idx}`}>
						<UIText
							fontSize={{ xs: pxToRem(16), md: pxToRem(15), xl: pxToRem(16) }}
							lineHeight={pxToRem(22)}
							fontWeight={600}
							lineClamp={1}
						>
							{name} {position}
						</UIText>
					</UILink>
					<UILink href={`mailto:${email}`}>
						<UIText
							display={{ xs: '-webkit-box', md: 'none', xl: '-webkit-box' }}
							fontSize={pxToRem(14)}
							lineHeight={pxToRem(22)}
							lineClamp={1}
							color={color.colGray5}
							sx={{
								wordBreak: 'break-all',
							}}
						>
							{email}
						</UIText>
					</UILink>
				</UIFlex>
			</UIFlex>
			<Box flexShrink="0">
				<SubscribeButton isSubscribed={isSubscribed} idx={idx} target="journalist" />
			</Box>
		</UIFlex>
	)
}

export default AuthorSlideItem
